import './ContentCount.sass';

import React, { FC, useMemo } from 'react';

import { ContentCountProps } from './ContentCount.interface';
import { useTranslator } from '$hooks';
import { IcHot28 } from '$assets';

export const ContentCount: FC<ContentCountProps> = (props) => {
  const { photos, videos } = props;

  const t = useTranslator();

  const text = useMemo(() => {
    if (photos > 0 && videos > 0) {
      return t('content_count_photos_and_videos', {
        photos: t('photos_count', { count: photos }),
        videos: t('videos_count', { count: videos }),
      });
    } else if (photos > 0) {
      return t('content_count_photos', { photos: t('photos_count', { count: photos }) });
    } else if (videos > 0) {
      return t('content_count_videos', { videos: t('videos_count', { count: videos }) });
    } else {
      return t('content_count_empty');
    }
  }, [t, photos, videos]);

  return (
    <div className="ContentCount">
      <IcHot28 />
      {text}
    </div>
  );
};
